import { ChakraBox } from "@airhelp/react-ui-components";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { useLanguage } from "contexts/LocalizationContext/hooks";
import useDeviceSize from "hooks/useDeviceSize";
import MenuLink from "modules/common/components/MenuLink";
import { MenuLinkWithSubmenuDesktop, MenuLinkWithSubmenuMobile } from "./MenuLinkWithSubmenu";

export const MenuItems = ({ menu }: { menu: Array<MenuExtendedProps> }) => {
  const language = useLanguage();
  const { isDesktop } = useDeviceSize();

  const menuLinksMapped = (
    <>
      {menu.map((item: MenuExtendedProps) => {
        const { subMenu, label, languages } = item;

        const menuLink = (
          <MenuLink
            variant="footerDark"
            menuItem={item}
            linkType={subMenu ? "span" : ""}
            fontWeight="semibold"
            py={{ base: 4, lg: 0 }}
            display="block"
          />
        );

        const isNoTSupportedLanguage = languages?.length > 0 && !languages.includes(language);

        if (isNoTSupportedLanguage) return null;

        return (
          <ChakraBox key={label} ml={{ lg: 4, xl: 9 }}>
            {subMenu ? (
              isDesktop ? (
                <MenuLinkWithSubmenuDesktop menulink={menuLink} submenu={subMenu} />
              ) : (
                <MenuLinkWithSubmenuMobile menulink={menuLink} submenu={subMenu} />
              )
            ) : (
              menuLink
            )}
          </ChakraBox>
        );
      })}
    </>
  );

  return menuLinksMapped;
};
